import React, { useEffect, useState } from "react";
import DynamicTable from "../../widgets/dynamicTable/DynamicTable";
import HelperMetiers360 from "../../../services/HelpersMetiers360";
import { useStoreState } from "easy-peasy";
import { Link } from "react-router-dom";
import useCustomGetStoreState from "../../../hooks/useCustomGetStoreState";

const ParcelTableComponent = ({
    parcels,
    withParams = false
}) => {

    const {allClients} = useCustomGetStoreState('clients');

    const orderActionsSlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher("orders"));
    const oneOrderSlug = orderActionsSlugs?.readOne ?? null;
    const clientActionSlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher('clients'));
    const oneClientSlug = clientActionSlugs?.readOne ?? null;

    const [enrichedParcels, setEnrichedParcels] = useState(parcels);

    useEffect(() => {
        if (allClients?.length >0 && parcels?.length >0) {
            setEnrichedParcels(parcels.map(parcel => {
                const client = allClients.find(client => client.uniqueId === parcel.clientUniqueId);
                return {...parcel,clientName:client?.clientName}}));
            }
    },[allClients, parcels])

    const parcelDeliveryLines = (parcelDeliveryLine) => {
        return parcelDeliveryLine?.map((deliveryLine) => (
            <div>{deliveryLine.quantity + " " + deliveryLine.orderLineName }</div>
        ))
    }

    const sortType = parcels?.length > 0 ?
    [
        {
            value : 'createdDate', label : "Date création",
            test : HelperMetiers360.isArrayContainsValue(parcels, "createdAt"),
            method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.createdAt?.date ?? a.createdAt, b.createdAt?.date ?? b.createdAt),
            display: (parcel) => parcel.createdAt ? 
                HelperMetiers360.getdisplayDateType(parcel.createdAt.date ? parcel.createdAt.date:parcel.createdAt, 'day') : '-',
        },
        {
            value : 'preparatoryOrder', label : "Bon de préparation",
            test : HelperMetiers360.isArrayContainsValue(parcels, "preparatoryOrder"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.preparatoryOrder?.id, b.preparatoryOrder?.id),
            display: (parcel) => {
                if(!parcel.preparatoryOrder?.id) return '-';
                return parcel.preparatoryOrder?.uniqueId && oneOrderSlug ?
                    <Link to={oneOrderSlug.replace(':uniqueId', parcel.preparatoryOrder.uniqueId)}>{parcel.preparatoryOrder.id}</Link>
                    : <>{parcel.preparatoryOrder.id}</>
            },
            flatDisplay: (parcel) => parcel.preparatoryOrder?.id ?? "-"
        },
        {
            value : 'orderNumber', label : "Numero d'ordre",
            test : HelperMetiers360.isArrayContainsValue(parcels, "orderNumber"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.orderNumber, b.orderNumber),
            display: (parcel) => parcel.orderNumber ? parcel.orderNumber : '-'
        },
        {
            value : 'trackingNumber', label : 'Numero de suivi',
            test : HelperMetiers360.isArrayContainsValue(parcels, "trackingNumber"),
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.trackingNumber, b.trackingNumber),
            display: (parcel) => parcel.trackingNumber  ? parcel.trackingNumber : '-'
        },
        {
            value : 'trackingUrl', label : 'Suivi',
            test : HelperMetiers360.isArrayContainsValue(parcels, "trackingUrl"),
            display: (parcel) => parcel.trackingUrl  ?
                <a href={parcel.trackingUrl}>lien</a>
                : '-'
        },
        {
            value : 'statusLabel', label : 'Status',
            test : HelperMetiers360.isArrayContainsValue(parcels, "statusLabel"),
            method : (a, b) => HelperMetiers360.localeCompareWithNullable(a.statusLabel, b.statusLabel),
            display: (parcel) => parcel.statusLabel ? parcel.statusLabel : '-'
        },
        {
            value : 'deliveryServiceName', label : 'Service de livraison',
            test : HelperMetiers360.isArrayContainsValue(parcels, "deliveryServiceName"),
            method : (a, b) => HelperMetiers360.localeCompareWithNullable(a.deliveryServiceName, b.deliveryServiceName),
            display: (parcel) => parcel.deliveryServiceName ? parcel.deliveryServiceName : '-'
        },
        {
            value : 'deliveryLines', label : 'Contenu du colis',
            test : parcels?.find(parcel => parcel.deliveryLines?.length > 0) !== undefined,
            method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.deliveryLines?.length, b.deliveryLines?.length),
            display: (parcel) => parcelDeliveryLines(parcel.deliveryLines)
        },
        {
            value: 'clientUniqueId', label: "Établissement",
                test : HelperMetiers360.isArrayContainsValue(parcels, "clientUniqueId"),
                method: (a, b) => HelperMetiers360.localeCompareWithNullable(a.clientName, b.clientName),
                display: (parcel) => {
                    if(!parcel.clientUniqueId || !parcel.clientName) return '-';
                    return parcel.clientUniqueId && oneClientSlug ?
                        <Link to={oneClientSlug.replace(':uniqueId', parcel.clientUniqueId)}>{parcel.clientName}</Link>
                        : <>{parcel.clientName}</>;
                },
                flatDisplay: (parcel) => parcel.clientName
        }
    ]
    :null;

    return sortType && <DynamicTable
        contentTable = {enrichedParcels}
        contentSort = {sortType}
        valueInitSort = "orderNumber"
        index = 'uniqueId'
        filename="colis_bon_preparation"
        withParams={withParams}
    />;
};

export default ParcelTableComponent;